import { Link, useNavigate } from "react-router-dom";
import { CalendarDays, ChevronRight, Fuel, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { STATUS_LABELS } from "@/components/admin/OrdersTable";

const STATUS_STYLES = {
  pendiente: "bg-amber-100 text-amber-800 border-amber-200",
  recogido: "bg-sky-100 text-sky-800 border-sky-200",
  en_proceso: "bg-indigo-100 text-indigo-800 border-indigo-200",
  listo: "bg-emerald-100 text-emerald-800 border-emerald-200",
  entregado: "bg-slate-100 text-slate-700 border-slate-200",
};

export const OrderCard = ({ order }) => {
  const navigate = useNavigate();
  const paid = order.payment_status === "pagado";
  const repeat = () =>
    navigate("/reservar", {
      state: {
        repeat: {
          items: order.items.filter((i) => i.service_id !== "desplazamiento"),
          address: order.customer?.address || "",
          notes: order.notes || "",
        },
      },
    });
  return (
    <article data-testid={`customer-order-${order.order_number}`}
      className="bg-white border border-slate-200 rounded-2xl p-5 sm:p-6 transition-shadow duration-200 hover:shadow-md">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-xs text-slate-500">Pedido</p>
          <p className="font-heading font-bold text-slate-900 notranslate">{order.order_number}</p>
        </div>
        <div className="flex items-center gap-2">
          <span className={`text-xs font-medium px-2.5 py-1 rounded-full border ${paid ? "bg-green-50 text-green-700 border-green-200" : "bg-slate-50 text-slate-500 border-slate-200"}`}>
            {paid ? "Pagado" : "Pago pendiente"}
          </span>
          <span data-testid="customer-order-status" className={`text-xs font-medium px-2.5 py-1 rounded-full border ${STATUS_STYLES[order.status]}`}>
            {STATUS_LABELS[order.status]}
          </span>
        </div>
      </div>
      <ul className="mt-4 space-y-1 text-sm text-slate-600">
        {order.items.map((i) => (
          <li key={i.service_id} className="flex justify-between gap-4">
            <span className="flex items-center gap-1.5">
              {i.service_id === "desplazamiento" && <Fuel className="h-3.5 w-3.5 text-cyan-500" />}
              {i.name} {i.quantity > 1 && `x${i.quantity}`}
            </span>
            <span>{(i.unit_price * i.quantity).toFixed(2)} €</span>
          </li>
        ))}
      </ul>
      <div className="mt-4 pt-4 border-t border-slate-100 flex flex-wrap items-center justify-between gap-3">
        <span className="text-sm text-slate-500 flex items-center gap-1.5">
          <CalendarDays className="h-4 w-4" /> Recogida {order.pickup_date}
        </span>
        <span className="font-heading font-bold text-cyan-600">{order.total.toFixed(2)} €</span>
        <div className="flex items-center justify-between gap-3 w-full sm:w-auto">
          <Link to={`/seguimiento?pedido=${order.order_number}`} data-testid="customer-order-track-link"
            className="text-sm font-medium text-slate-700 hover:text-cyan-700 inline-flex items-center gap-1 py-2">
            Seguimiento <ChevronRight className="h-4 w-4" />
          </Link>
          <Button type="button" size="sm" onClick={repeat} data-testid="customer-order-repeat-btn"
            className="rounded-full bg-cyan-500 hover:bg-cyan-600 h-9 px-4 text-xs">
            <RotateCcw className="h-3.5 w-3.5 mr-1.5" /> Repetir pedido
          </Button>
        </div>
      </div>
    </article>
  );
};
